/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { loadingRequest } from 'src/app/services/appconst';
import { GeneralserviceService } from 'src/app/services/generalservice.service';
import {
  IWishlistItemIconsData,
  WishlistServiceService,
} from 'src/app/services/wishlist-service.service';

@Component({
  selector: 'app-wishlist-icons',
  templateUrl: './wishlist-icons.component.html',
  styleUrls: ['./wishlist-icons.component.scss'],
})
export class WishlistIconsComponent implements OnInit {
  @Input() queryParams: any;
  @Output() onSelectImage: EventEmitter<any> = new EventEmitter();

  wishListItemsIcon: IWishlistItemIconsData[] = [];

  loadingStateData = loadingRequest; // Get the Loading State Date from the Loading Request Enum
  loadingstate = loadingRequest.loading; // Set the Initial State to Loading

  constructor(
    public generalService: GeneralserviceService,
    public wishListService: WishlistServiceService
  ) {}

  ngOnInit() {
    this.loadWishListItemIcon();
  }

  async loadWishListItemIcon() {
    this.loadingstate = loadingRequest.loading;

    await this.wishListService.authservice.onLoad();

    await this.wishListService
      .getWishListItemsImage({ perpage: 20 })
      .subscribe(
        (res) => {
          // console.log(res);
          if (!res.meta.total) {
            this.loadingstate = loadingRequest.noData;
          } else if (res.meta.total) {
            this.loadingstate = loadingRequest.success;
            this.wishListItemsIcon = res.data;
            // console.log(res);
          }
        },
        (err) => {
          this.loadingstate = loadingRequest.error;
          // console.log(err);
        }
      )
      .add(() => {});
  }

  selectImage(index) {
    this.onSelectImage.emit(this.wishListItemsIcon[index].imageUrl);
  }
}
